import React, { useEffect, useState } from "react";
import {
  Grid,
  Typography,
  CardContent,
  Box,
  TextField,
  Button,
  Card,
  Container,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import axios from "axios";
import "./OrderIdReturn.css";
import { Table } from "react-bootstrap";

const RetailerDashboard = () => {
  const [isSidebarVisible, setSidebarVisible] = useState(true);
  const [orderId, setOrderId] = useState("");
  const [returnList, setReturnList] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1100) {
        setSidebarVisible(false);
      } else {
        setSidebarVisible(true);
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleContinue = async () => {
    if (orderId === "") {
      alert("Order id cannot be empty");
      return;
    }

    try {
      const res = await axios.get(
        `http://api.meddaily.in/order_details?order_id=${orderId}`,
        {
          headers: {
            token: sessionStorage.getItem("token"),
          },
        }
      );
      if (res.status === 200) {
        console.log(res);
        navigate("/retdetails", { state: { apiResponse: res.data.data } });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleChange = (event) => {
    setOrderId(event.target.value);
  };

  const fetchReturnList = async () => {
    try {
      const response = await axios.get(
        "http://api.meddaily.in/get_all_return",
        {
          headers: {
            token: sessionStorage.getItem("token"),
          },
        }
      );
      if (response.status === 200) {
        setReturnList(response.data.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchReturnList();
  }, []);

  return (
    <div style={{ backgroundColor: "#f5f5f9", minHeight: "100vh" }}>
      <Grid container>
        {isSidebarVisible && (
          <Grid item xs={12} md={3}>
            <Sidebar />
          </Grid>
        )}
        <Grid item xs={12} md={isSidebarVisible ? 9 : 12}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Navbar />
              <Grid item xs={11}>
                <Card style={{ marginTop: "24px", backgroundColor: "#ffffff" }}>
                  <CardContent>
                    <Container maxWidth="lg">
                      <Grid container spacing={2} alignItems="center">
                        <Grid item xs={9}>
                          <TextField
                            label="Enter Order ID"
                            fullWidth
                            name="orderId"
                            value={orderId}
                            onChange={handleChange}
                          />
                        </Grid>
                        <Grid item xs={3}>
                          <button
                            className="continue1"
                            onClick={handleContinue}
                          >
                            Continue
                          </button>
                        </Grid>
                      </Grid>
                    </Container>
                  </CardContent>
                </Card>
              </Grid>
              <h3>Recent Return</h3>
              <Grid item xs={12}>
                <Card style={{ marginTop: "24px", backgroundColor: "#ffffff" }}>
                  <CardContent>
                    <Container maxWidth="lg">
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell>Order ID</TableCell>
                            <TableCell>Product</TableCell>
                            <TableCell>Quantity</TableCell>
                            <TableCell>TOTAL PRICE</TableCell>
                            <TableCell>Status</TableCell>
                            <TableCell>Details</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {returnList.map((order) => (
                            <TableRow key={order._id}>
                              <TableCell>{order.order_id}</TableCell>
                              <TableCell>
                                {order?.products[0]?.name || "NA"}
                              </TableCell>
                              <TableCell>
                                {order?.products[0]?.quantity || "NA"}
                              </TableCell>
                              <TableCell>{order.price}</TableCell>
                              <TableCell>
                                {order.order_status === 0 && "Cancelled"}
                                {order.order_status === 1 && "Order Shipped"}
                                {order.order_status === 3 &&
                                  "Order Delivered"}
                                {order.order_status === 4 && "Order Placed"}
                              </TableCell>
                              <TableCell>
                                <button
                                  className="view-details-button"
                                  onClick={() =>
                                    navigate("/orderdetails", {
                                      state: { id: order.order_id },
                                    })
                                  }
                                >
                                  View Details
                                </button>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </Container>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default RetailerDashboard;
